import styled from "styled-components";
import { colors, types } from "../../../libs/themes";
import { glassMixin } from "../../../styles";

interface ScrollableListProps {
    scrollable: boolean;
}

export const ScrollableList = styled.div.withConfig({
    shouldForwardProp: (prop) => !["scrollable"].includes(prop),
})<ScrollableListProps>`
    display: flex;
    flex-direction: row;
    overflow-x: ${({ scrollable }) => (scrollable ? "scroll" : "hidden")};
    overflow-y: hidden;
    scroll-behavior: smooth;
    padding-right: 16px;

    ${({ scrollable }) =>
        scrollable &&
        `
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  `}
`;

export const SeeAllWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
export const MainWrapper = styled.div`
    display: flex;
    gap: 50px;
`;

export const LeftSection = styled.div`
    flex: 0 0 35%;
    @media (max-width: 1280px) {
        flex: 1 1 100%;
    }
`;

export const LeftContent = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: 3px;
    height: 100%;
    justify-content: space-between;
`;

export const RightSectionWrapper = styled.div`
    width: 100%;
`;

export const CardTextWrapper = styled.div`
    padding: 10px 0;
`;

export const SidebarCardWrapper = styled.div`
    padding: 10px 10px 10px 10px;
`;
export const Container = styled.div`
    padding-left: 0px;
`;

export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
`;

export const SubtitleActionsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
    flex-direction: column;
`;

export const Title = styled.div`
    font-size: ${types.headers.main};
    font-weight: 600;
    margin: 0;
    line-height: 1;
    word-break: break-word;
    white-space: normal;
    max-width: 100%;

    @media (max-width: 1920px) {
        font-size: ${types.headers.main52};
    }

    @media (max-width: 1280px) {
        font-size: ${types.headers.main42};
    }

    @media (max-width: 900px) {
        font-size: ${types.headers.main36};
    }

    @media (max-width: 768px) {
        font-size: ${types.headers.main30};
    }
`;

export const Subtitle = styled.div`
    color: ${colors.background.mediumGray};
    ${types.headers.xSmall};
    margin: 0;
    line-height: 1;
    padding-left: 6px;
`;

export const RightSection = styled.div``;

export const BigCardWrapper = styled.div`
    position: relative;
    overflow: visible;
`;

export const CardDetailsWrapper = styled.div``;

export const CardTitle = styled.div`
    ${types.headers.main30};
    margin: 0;
`;

export const RatingWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

export const RatingValue = styled.span`
    font-weight: 600;
`;

export const Director = styled.span`
    margin-left: 10px;
`;

export const ScrollButtonsWrapper = styled.div`
    display: flex;
    gap: 15px;
    margin-top: 18px;
    padding-left: 6px;
    padding-bottom: 50px;
    @media (max-width: 900px) {
        margin-top: 50px;
    }
`;

export const ScrollButton = styled.button`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid ${colors.border.black};
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;

    ${glassMixin}
    background-color: rgb(184, 180, 180, 0.5);

    &:hover {
        transform: scale(1.1);
        cursor: pointer;
    }
`;

export const CardTitleText = styled.div`
    ${types.headers.itemMedium};
    padding-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    margin-bottom: 5px;
`;

export const CardSubtitleWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const CardSubtitleText = styled.div`
    margin: 0;
    ${types.headers.normal};

    span {
        font-weight: 400;
        margin-left: 5px;
    }
`;

export const TitleSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 12px;
`;

export const SeeAllButton = styled.button`
    ${types.headers.xSmall};
    background: transparent;
    border: 1px solid black;
    color: black;
    cursor: pointer;
    padding: 8px 16px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: background-color 0.3s;

    &:hover {
        background-color: ${colors.background.hoverLight};
    }

    @media (max-width: 600px) {
        padding: 6px 12px;
    }
`;
